export default {
  title: 'Apps',

  labels: {
    appInfo: 'App info',
    planInfo: 'Plan info',
    modulesInfo: 'Modules info',
    addonsInfo: 'Addons info',
    images: 'Images',
    name: 'Name',
    subdomain: 'Subdomain',
    manager: 'Owner',
    country: 'Country',
    province: 'Province',
    address: 'Address',
    status: 'App is active',
    private: 'App is private',
    language: 'Language',
    currency: 'Currency',
    timezone: 'Region',
    financialYearStart: 'Fiscal Year Start',
    supportNumber: 'Support number',
    email: 'Email',
    maxDebt: 'Credit',
    modules: 'Modules',
    addons: 'Addons',
    product: 'Product',
    plan: 'Plan',
    period: 'Period ({type})',
    price: 'Price',
    totalPrice: 'totalPrice',
    prevStep: 'Previous step',
    nextStep: 'Next step',
    createInvoice: 'Create invoice',
    pay: 'Pay and enable app',
    periodPerMonth: ' / {num} mo',
    delete: 'Delete'
  },

  wizard: {
    generalInfo: {
      label: 'General info',
      description: 'App general info'
    },
    product: {
      label: 'Product',
      description: 'Select product'
    },
    plan: {
      label: 'Plan',
      description: 'Select Plan'
    },
    module: {
      label: 'Modules',
      description: 'Select modules'
    },
    addon: {
      label: 'Addons',
      description: 'Select addons'
    },
    checkout: {
      label: 'Checkout',
      description: 'Checkout'
    },
  },

  table: {
    header: {
      select: 'Select',
      row: 'Row',
      logo: 'Logo',
      date: 'Created Date',
      name: 'Name',
      product: 'Product',
      manager: 'Owner',
      city: 'City',
      province: 'Province',
      country: 'Country',
      supportNumber: 'Support Number',
      email: 'Email',
      maxDebt: 'Credit',
      balance: 'Balance',
      status: 'Status',
      private: 'Private',
      publicId: 'Public id',
      expireDate: 'Expired At',
      delete: 'Delete',
      restore: 'Restore'
    }
  },

  notifications: {
    wrongInputValue: 'Some input has wrong value',

    insert: {
      success: 'App insert successfully',
      error: 'Insert app has error'
    },

    createInvoice: {
      success: 'App invoice insert successfully',
      error: 'Insert app invoice has error'
    },

    edit: {
      success: 'App update successfully',
      error: 'Edit app has error'
    },

    maxDebt: {
      success: 'App update successfully',
      error: 'Edit app has error'
    },

    deploy: {
      error: 'App deploy has error'
    },

    enable: {
      success: 'App enable successfully',
      error: 'Enable app has error'
    },

    disable: {
      success: 'App disable successfully',
      error: 'Disable app has error'
    },

    delete: {
      success: 'App removed successfully',
      error: 'Delete app has error'
    },

    restore: {
      success: 'App restored successfully',
      error: 'Restore app has error'
    },

    parseError: {
      name: 'Name is not valid or exist',
      subdomain: 'Subdomain is not valid or exist',
      sport: 'Sport is not valid',
      supportNumber: 'Support number is not valid or exist',
    }
  },

  validators: {
    subdomain: 'Subdomain only accept English character',
    subdomainNumber: 'Subdomain cant start with digits',
    subdomainExist: 'Subdomain is used',
    illegalSubdomain: 'Subdomain is illegal or used'
  },

  confirmations: {
    delete: {
      title: 'Delete app confirmation',
      body: 'Are you sure about delete this app?'
    },

    deploy: {
      title: 'Deploy app confirmation',
      body: 'Are you sure about deploy this app?'
    },

    routeBack: {
      title: 'Cancel the App addition',
      body: 'If you leave this page, all the entered information will be lost. Are you sure you want to cancel adding the app?'
    },

    changeStatus: {
      title: 'Change status app confirmation',
      body: 'Are you sure about change status of this app?'
    }
  },

  statusTypes: {
    all: 'All',
    signup: 'Signup',
    created: 'Created',
    pending: 'Pending',
    deploying: 'Deploying',
    active: 'Active',
    expired: 'Expired',
    upgrade: 'Updating',
    suspend: 'Suspend'
  },

  products: {
    accounting: {
      title: 'Accounting',
      description: ''
    },
    booking: {
      title: 'Booking',
      description: ''
    }
  },

  list: {
    title: 'Apps'
  },

  trash: {
    title: 'Removed apps list'
  },

  insert: {
    title: 'Create App'
  },

  edit: {
    title: 'Edit App',
    dynamicTitle: 'Edit {name}'
  },

  profile: {
    title: 'App profile',
    dynamicTitle: '{name} profile',

    importantData: {
      manager: 'Manager',
      status: 'Status',
      private: 'Private',
      publicId: 'Public id',
      balance: 'Balance',
      maxDebt: 'Credit'
    },

    actions: {
      dashboard: 'Dashboard',
      subscription: 'Subscriptions',
      maxDebt: 'Credit',
      showTransactions: 'Transactions',
      appRequests: 'Requests',
      appReceives: 'Receives',
      paymentMethods: 'Payment methods',
      invoices: 'Sales',
      refundInvoices: 'Refunds',
      clubLogin: 'Login to panel',
      appDeploy: 'Deploy',
      employees: 'Employees',
      suspend: 'Suspend',
      unsuspend: 'Unsuspend',
      logs: 'Activity logs'
    }
  },

  requests: {
    title: 'Apps requests',

    labels: {
      department: 'Department',
      type: 'Type',
      status: 'Status',
      details: 'Details',
      answer: 'Answer',
      reject: 'Reject',
      accept: 'Accept'
    },

    table: {
      header: {
        row: 'Row',
        date: 'Date',
        department: 'Department',
        details: 'Details',
        type: 'Type',
        status: 'Status'
      }
    },

    departmentOptions: {
      all: 'All',
      1: 'Technical',
      2: 'Financial'
    },

    typeOptions: {
      all: 'All',
      1: 'Update app info'
    },

    statusOptions: {
      all: 'All',
      0: 'Created',
      1: 'Pending',
      2: 'Accepted',
      3: 'Rejected'
    },

    notifications: {
      emptyAnswer: 'No answer entered for the request',

      reject: {
        success: 'App request successfully rejected',
        error: 'Reject app request has error'
      },

      confirm: {
        success: 'App request successfully accepted',
        error: 'Accept app request has error'
      }
    },

    list: {
      title: 'App requests list'
    },

    profile: {
      title: 'App request'
    },

    clubInfo: {
      title: 'App info',

      labels: {
        generalInfo: 'General info',
        name: 'Name',
        locale: 'Locale',
        onlineBooking: 'Enable online booking status',
        telInfo: 'Tel info',
        province: 'Province',
        city: 'City',
        address: 'Address',
        supportNumber: 'Support number',
        email: 'Email'
      }
    }
  },

  receives: {
    title: 'App receives',

    list: {
      title: 'App receives',
    }
  },

  invoices: {
    title: 'App invoices'
  },

  refundInvoices: {
    title: 'App refund invoices'
  },

  employees: {
    title: 'App employees',

    labels: {
      user: 'User',
      owner: 'Owner'
    },

    notifications: {
      noUserSelected: 'User not selected',
      insert: {
        success: 'Employee successfully created',
        error: 'Create employee has error'
      },
      delete: {
        success: 'Employee successfully deleted',
        error: 'Delete employee has error'
      },
      suspend: {
        success: 'Employee successfully suspend',
        error: 'Suspend employee has error'
      },
      active: {
        success: 'Employee successfully actived',
        error: 'Active employee has error'
      }
    },

    confirmations: {
      delete: {
        title: 'Delete employee confirmation',
        body: 'Are you sure about delete this employee?'
      },
      active: {
        title: 'Active employee confirmation',
        body: 'Are you sure about active this employee?'
      },
      suspend: {
        title: 'Suspend employee confirmation',
        body: 'Are you sure about suspend this employee?'
      },
    },

    insert: {
      title: 'Create employee'
    }
  },

  deploy: {
    title: 'Deploy App',
    dynamicTitle: 'Deploy {name}',

    description: 'For deploy app, click on the Deploy button',

    labels: {
      codeValidate: 'Code validity ',
      second: 'Second',
    },

    steps: {
      request_created: 'Request created',
      subdomain_created: 'Subdomain created',
      database_created: 'Database created',
      environment_created: 'Environment created',
      database_migrated: 'Database migrated',
      database_seeded: 'Database seeded',
      supervisor_created: 'Supervisor created',
      deployed: 'App deployed'
    },

    notifications: {
      success: {
        title: 'The system of {name} app has been successfully launched',
        body: 'To view the management panel of this app, click on the button below'
      },
      parseError: {
        hasDeployed: 'This app was deployed'
      }
    },

    sendOtp: {
      title: 'Login to app confirmation',
      text: 'Confirmation otp of login app sent, please enter code'
    },

    actions: {
      deploy: 'Deploy',
      goToClub: 'Login to panel'
    }
  },

  transactions: {
    title: 'App turnover',
    dynamicTitle: 'turnover',
    documentTitle: 'App Turnover Document',

    table: {

      header: {
        docNumber: 'Document Number',
        date: 'Date',
        documentation: 'Documents',
        price: 'Amount',
        balance: 'Balance'
      }
    },

    types: {
      sale: 'Sale',
      receive: 'Receive'
    }
  },

  dashboard: {
    title: 'App dashboard',

    labels: {
      status: 'Status',
      tickets: 'Tickets',
      documents: 'Documents',
      activeUsers: 'Active users',
      active: 'Active',
      disable: 'Disable',
      dynamicDayRemaining: '{num} day remaining | {num} day remaining | {num} days remaining',
    }
  },

  paymentMethods: {
    title: 'App payment methods',

    labels: {
      autoPayment: 'Auto payment',
      title: 'Title',
      cardNumber: 'Card number',
      cvv2: 'CVV2',
      expireDate: 'Expire date'
    },

    table: {
      header: {
        row: 'Row',
        title: 'Title',
        date: 'Date',
        expireDate: 'Expire date',
        cardNumber: 'Card number',
        autoPayment: 'Auto payment',
        action: 'Actions'
      }
    },

    notifications: {
      setAutoPayment: 'Auto payment is enabled for another payment method',

      insert: {
        success: 'Payment method insert successfully',
        error: 'Insert payment method has error'
      },
      edit: {
        success: 'Payment method update successfully',
        error: 'Edit payment method has error'
      },
      delete: {
        success: 'Payment method removed successfully',
        error: 'Delete payment method has error'
      },
      parseError: {
        cardNumber: 'Card number is not valid',
        expireDate: 'Card number expire date is not valid',
      }
    },

    confirmations: {
      autoPayment: {
        title: 'Ato payment confirmation',
        body: 'Only one payment method can enable auto payment, Are you sure about enable auto payment?'
      },
      delete: {
        title: 'Delete payment method confirmation',
        body: 'Are you sure about delete this payment method?'
      },
    },

    list: {
      title: 'App payment methods'
    },

    insert: {
      title: 'Create app payment method'
    },

    edit: {
      title: 'Edit app payment method'
    }
  },

  maxDebt: {
    title: 'App credit',
    dynamicTitle: '{name} credit'
  },

  logs: {
    title: 'App Logs'
  }
}
